// extracted by mini-css-extract-plugin
module.exports = {"DownloadBtn":"DownloadBtn_DownloadBtn__2t3zX"};